import { render, staticRenderFns } from "./AddPointTagsModle.vue?vue&type=template&id=637614c6&scoped=true&"
import script from "./AddPointTagsModle.vue?vue&type=script&lang=js&"
export * from "./AddPointTagsModle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637614c6",
  null
  
)

export default component.exports